<template>


    <section class="proyectos-home -finalizados" v-if="projects.length != 0">

        
        <h3 class="title-intro no-line small">Proyectos que hemos conseguido 
          gracias <strong>a donaciones</strong></h3>
        
        <div class="contenedor-slider slider-proyectos-no-finalizados container">
          <h2 class="big-title -white">Gracias</h2>
          <slick
            ref="slick"
            :options="slickOptions">
            <div class="slide -proyecto" v-for="(project,key) in projects">
              <proyecto-el :key="key" :project="project"></proyecto-el>
            </div>
          </slick>
        </div>
  
  
      </section>

</template>

<script>

import Slick from 'vue-slick';
import proyecto from '@/components/parts/proyecto';

import {mapGetters} from 'vuex'

  export default {
    name: 'proyectos-finalizados',
    data(){
        return{
            slickOptions: {
                slidesToShow: 1
            },
        }
    },
    components : {
        'proyecto-el' : proyecto,
         Slick
    },
    computed:{
      ...mapGetters({
        projects : 'getProjectsfinish'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/projects-finalizados.vue